<template>
    <Link
        :href="href"
        :as="as"
        :data="data"
        :method="method"
        :replace="replace"
        :preserve-state="preserveState"
        :preserve-scroll="preserveScroll"
        :only="only"
        :headers="headers"
        :class="[sizeClass, classes, textColorClass]"
        class="focus:shadow-outline-gray duration-50 inline-flex items-center place-content-center text-white text-sm font-medium tracking-wide border border-transparent rounded-md focus:outline-none uppercase transition ease-in-out"
    >
        <slot></slot>
        <slot name="icon"></slot>
    </Link>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: "brand",
        },
        size: {
            type: String,
            default: "base",
        },
        as: {
            type: String,
            default: "a",
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        href: {
            type: String,
            required: true,
        },
        method: {
            type: String,
            default: "get",
        },
        replace: {
            type: Boolean,
            default: false,
        },
        preserveScroll: {
            type: Boolean,
            default: false,
        },
        preserveState: {
            type: Boolean,
            default: null,
        },
        only: {
            type: Array,
            default: () => [],
        },
        headers: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        classes() {
            if (this.color === "white") {
                return _.join(["bg-" + this.color, "ring-gray-500", "hover:bg-gray-150", "active:bg-gray-100", "disabled:bg-gray-300", "border-gray-300"], " ")
            }
            return _.join(["bg-" + this.color + "-500", "hover:bg-" + this.color + "-400", "active:bg-" + this.color + "-400", "disabled:bg-gray-300"], " ")
        },

        textColorClass() {
            return this.color === "white" ? "text-gray-600" : "text-white"
        },
        sizeClass() {
            if (this.size === "sm" || this.size === "") {
                return "text-xs py-2 px-5"
            }

            if (this.size === "base") {
                return "text-sm py-3 px-6"
            }

            if (this.size === "md") {
                return "text-base py-3 px-4"
            }

            if (this.size === "lg") {
                return "text-lg py-4 px-5"
            }
        },
    },
}
</script>
